import React, { useState } from 'react';
import { Modal, Input, Button, Typography, Form, message } from 'antd';
import { FileText, X, Save } from 'lucide-react';
import dialerService from '../services/dialerService';

const { TextArea } = Input;

const NoteModalV2 = ({ isOpen, onClose, record }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      const res = await dialerService.addNotes(record.Id, values.notes);

      // Usually these WCF services return a boolean or a success message in parseDetails
      if (res) {
        message.success('Note saved successfully!');
        form.resetFields();
        onClose();
      } else {
        message.error('Failed to save note. Please try again.');
      }
    } catch (error) {
      console.error('Failed to save note:', error);
      message.error('An error occurred while saving the note.');
    } finally {
      setLoading(false);
    }
  };

  if (!record) return null;

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <FileText size={20} className="text-slate-600" />
          <span className="text-lg font-bold text-slate-800">Add Note</span>
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={500}
      className="premium-modal"
      closeIcon={<X size={20} className="text-slate-400 hover:text-slate-600" />}
      centered
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        className="py-4"
      >
        <Form.Item
          name="notes"
          label={<span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Internal Note</span>}
          rules={[{ required: true, message: 'Please enter a note' }]}
        >
          <TextArea
            rows={6}
            placeholder="Type your notes here. These are private to your team..."
            className="rounded-2xl p-4 bg-slate-50 border-slate-100 hover:bg-white transition-all"
          />
        </Form.Item>

        <div className="flex justify-end gap-3 mt-8">
          <Button onClick={onClose} className="rounded-xl font-bold h-11 px-6">
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            icon={<Save size={16} />}
            className="rounded-xl font-bold h-11 px-10 bg-slate-700 hover:bg-slate-800 shadow-lg shadow-slate-200 border-none flex items-center gap-2"
          >
            Save Note
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default NoteModalV2;
